




































































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import { getDefaultAloProfilExclusion } from '@/models/alo/AloProfilExclusion';

@Component({
  name: 'GestionProfils',  
})
export default class GestionProfils extends Vue {
  private loading = false
  private showError = false  
  private showNew = false
  private newProfilExclusion = getDefaultAloProfilExclusion()
  
  private toolbarHeight = 50

  private get tableauHeight() {    
    return this.$store.myGetters.contentHeight - this.toolbarHeight - 25
  }

  onResize(){
    //@ts-ignore
    this.toolbarHeight = this.$refs.toolbar.$el.clientHeight
  }

  private get profilExclusionList() {
    return this.$store.myGetters.profilExclusionList
  }

  private get search(){
    return this.$store.myGetters.searchProfilExclusion
  }
  private set search(value){
    this.$store.myActions.UI_SET_SEARCH_PROFIL_EXCLUSION(value)
  }

  private get sortDesc(){
    return this.$store.myGetters.sortProfilExclusionDesc
  }
  private set sortDesc(value){
    this.$store.myActions.UI_SET_SORT_PROFIL_EXCLUSION_DESC(value)
  }

  private get sortBy(){
    return this.$store.myGetters.sortProfilExclusionBy
  }
  private set sortBy(value){
    this.$store.myActions.UI_SET_SORT_PROFIL_EXCLUSION_BY(value)
  }

  private get flux(){
    return this.$store.myGetters.flux
  }

  private headers = [
    { text: 'ID', value: 'id' },
    { text: 'Nom du profilExclusion', value: 'libelle' },
    { text: 'Marques exclues', value: 'nbMarque' },
    { text: 'Codics  exclus', value: 'nbCodic' },
    { text: 'Flux associés (ids)', value: 'flxIds' }
  ]

  created() {
    this.loading = true
     this.$store.myActions.ADM_FLUX_ENSURE().finally(() => {      
    })
    this.$store.myActions.ADM_PROFIL_EXCLUSION_REQUEST().finally(() => {
      this.loading = false
    })
  }

  openDetail(item: any) {
    this.$router.push({name:'ModifyProfilExclusion',params:{profilExclusionId:item.id}})
  }

  addProfilExclusion() {
    this.showNew = true  
    this.newProfilExclusion = {...getDefaultAloProfilExclusion(),ensId:this.$store.myGetters.userProfile.ensId}
  }

  save(){
    this.$store.myActions.ADM_PROFIL_EXCLUSION_SAVE_REQUEST(this.newProfilExclusion).then((profilExclusion)=>{
      this.showNew = false
      this.openDetail(profilExclusion)
    })    
  }
  
}
